// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3S-Sh","scotchT":"_2ynLQ","scotchB":"_1NkJD"};